import Checkbox from "@material-ui/core/Checkbox";
import FormControl from "@material-ui/core/FormControl";
import Grid from "@material-ui/core/Grid";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormLabel from "@material-ui/core/FormLabel";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import { withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import { Formik } from "formik";
import React from "react";
import * as Yup from "yup";
import {
  maxDate,
  minDate,
  SpecialRadioGroup,
  SpecialSelect,
  SSSCustom,
  StepButtons,
  TinCustom,
  ZipCustom,
  HomeAreaCode,
  HomeTelCustom2,
  MobileCustom
} from "../CommonComponents";
import styles from "../ewccstyle";
import { Consumer } from "./EWCCContext";

// const referencelist = [
//   { value: "1", label: "EastWest store/atm/website" },
//   { value: "2", label: "Family/Relatives/Friends" },
//   { value: "3", label: "Ads - Billboard ads" },
//   { value: "4", label: "Ads - Magazine" },
//   { value: "5", label: "Ads - Newspaper" },
//   { value: "6", label: "Ads - Radio" },
//   { value: "7", label: "Internet - Facebook" },
//   { value: "8", label: "Internet - Google" },
//   { value: "9", label: "Internet - others" },
//   { value: "10", label: "Others" }
// ];

const sexlist = [
  { value: "M", label: "Male" },
  { value: "F", label: "Female" }
];

const civilstatuslist = [
  { value: "S", label: "Single" },
  { value: "M", label: "Married" },
  { value: "W", label: "Widowed" },
  { value: "D", label: "Separated" }
];

const educlist = [
  { value: "HS", label: "High School" },
  { value: "SC", label: "Some College" },
  { value: "CO", label: "College" },
  { value: "GS", label: "Post Graduate" }
];

const citizenshiplist = [
  { value: "Filipino", label: "Filipino" },
  { value: "OTH", label: "Others" }
];

const homeownerlist = [
  { value: "OW", label: "Owned, Mortgage" },
  { value: "OM", label: "Owned, Not Mortgaged" },
  { value: "LP", label: "Living with Parents or Relatives" },
  { value: "CP", label: "Company Provided" },
  { value: "RN", label: "Rented" }
];

const PersonalInformation = withStyles(styles)(function(props) {
  // console.log(date)

  const { activeStep, handleBack, classes } = props;
  return (
    <Consumer>
      {context => (
        <Formik
          initialValues={{
            // reference: context.reference,
            // refothers: context.refothers,
            firstName: context.firstName,
            middleName: context.middleName,
            lastName: context.lastName,
            cardName: context.cardName,
            birthDate: context.birthDate,
            birthPlace: context.birthPlace,
            momName: context.momName,
            momName1: context.momName1,
            momName2: context.momName2,
            sex: context.sex,
            civilStatus: context.civilStatus,
            numberDependents: context.numberDependents,
            numberCar: context.numberCar,
            educ: context.educ,
            citizenship1: context.citizenship1,
            citizenship: context.citizenship,
            acr: context.acr,
            tinNo: context.tinNo,
            sssNo: context.sssNo,
            homeAddress: context.homeAddress,
            zipCode: context.zipCode,
            chkPermAddSameWithHomeAdd: context.chkPermAddSameWithHomeAdd,
            permanentAddress: context.permanentAddress,
            zipCode2: context.zipCode2,
            homeOwner: context.homeOwner,
            yearStay: context.yearStay,
            homeAreaCode: context.homeAreaCode,
            homePhone: context.homePhone,
            mobilePhone: context.mobilePhone,
            emailAddress: context.emailAddress,
            emailAddressAlt: context.emailAddressAlt,
            socMed: context.socMed
          }}
          validationSchema={Yup.object().shape(
            {
              // reference: Yup.string().required("Selection required"),
              firstName: Yup.string()
                .required("First name is required")
                .max(30, "First in Card is too long"),
              middleName: Yup.string()
                .required("Middle name is required")
                .max(30, "Middle in Card is too long"),
              lastName: Yup.string()
                .required("Last name is required")
                .max(30, "Last in Card is too long"),
              cardName: Yup.string()
                .required("Name in Card is required")
                .matches(/^([a-zA-Z0-9\s]*)$/, "Invalid special characters")
                .max(19, "Name in Card is too long"),
              momName: Yup.string()
                .required("Mother's Maiden Name is required")
                .max(30, "Text too long"),
              momName1: Yup.string()
                .required("Mother's Maiden Name is required")
                .max(30, "Text too long"),
              momName2: Yup.string()
                .required("Mother's Maiden Name is required")
                .max(30, "Text too long"),
              birthPlace: Yup.string()
                .required("Place of birth is required")
                .max(250, "Text too long"),
              emailAddress: Yup.string()
                .email("Must be a valid email")
                .required("Primary E-mail Address is required"),
              emailAddressAlt: Yup.string()
                .email("Must be a valid email")
                .max(200, "Text too long"),
              birthDate: Yup.string().required("Birthdate is required"),
              sex: Yup.string().required("Gender is required"),
              civilStatus: Yup.string().required("Civil Status is required"),
              numberDependents: Yup.number()
                .positive("Invalid Entry")
                .integer()
                .min(0, "Invalid Entry")
                .max(30, "Invalid Entry")
                .required("No. of Dependents is required"),
              numberCar: Yup.number()
                .positive("Invalid Entry")
                .integer()
                .min(0, "Invalid Entry")
                .max(1000, "Invalid Entry"),
              educ: Yup.string().required("Education is required"),
              tinNo: Yup.string()
                .matches(/\d\d\d-\d\d\d-\d\d\d/, "Invalid TIN")
                .required("Tax Identification Number (TIN) is required"),
              sssNo: Yup.string()
                .matches(/\d\d-\d\d\d\d\d\d\d-\d/, "Invalid SSS number")
                .required("SSS/GSIS No. is required"),
              homeAddress: Yup.string().required(
                "Present/Home Address is required"
              ),
              zipCode: Yup.string()
                .matches(/\d\d\d\d/, "Zip code is required")
                .required("Zip code is required"),
              zipCode2: Yup.string().matches(
                /\d\d\d\d/,
                "Zip code is required"
              ),
              yearStay: Yup.number()
                .positive()
                .min(0, "Invalid Entry")
                .integer()
                .required("Years of Stay is required"),
              homePhone: Yup.string()
                .matches(/\d\d\d-\d\d\d\d/, "Invalid Number")
                .when("homeAreaCode", {
                  is: homeAreaCode => homeAreaCode != undefined,
                  then: Yup.string().required("Home Phone Number is required")
                }),

              homeAreaCode: Yup.string()
                .matches(/\d\d/, "Invalid Area Code")
                .when("homePhone", {
                  is: homePhone => homePhone != undefined,
                  then: Yup.string().required("Area Code is required")
              }),
              mobilePhone: Yup.string()
                .matches(
                  /\(\d\d\)\s\d\d\d-\d\d\d-\d\d\d\d/,
                  "Invalid Mobile Phone Number"
                )
                .required("Mobile Phone Number is required"),
              homeOwner: Yup.string().required("Home Ownership is required"),
              citizenship1: Yup.string().required(
                "Citizenship/Nationality is required"
              )
            },
            [["homePhone", "homeAreaCode"]]
          )}


          // zipCode: Yup.number()
          //   .positive("Invalid Zipcode")
          //   .integer("Invalid Zipcode")
          //   .min(1000, "Invalid Zipcode"),
          // zipCode2: Yup.number()
          //   .positive("Invalid Zipcode")
          //   .integer("Invalid Zipcode")
          //   .min(1000, "Invalid Zipcode")
          // var
          // location={Yup.object().shape(
          //   {
          //     homeAreaCode: Yup.string().when("homePhone", {
          //       is: homePhone => homePhone != undefined,
          //       then: Yup.string().required()
          //       // otherwise: Yup.string()
          //     }),
          //     homePhone: Yup.string().when("homeAreaCode", {
          //       is: homeAreaCode => homeAreaCode != undefined,
          //       then: Yup.string().required()
          //       // otherwise: Yup.string()
          //     })
          //   },
          //   ["homePhone", "homeAreaCode"]
          // )}
          onSubmit={(values, actions) => {
            // context.updateState("reference", values.reference);
            // context.updateState("refothers", values.refothers);
            context.updateState("firstName", values.firstName);
            context.updateState("middleName", values.middleName);
            context.updateState("lastName", values.lastName);
            context.updateState("cardName", values.cardName);
            context.updateState("birthDate", values.birthDate);
            context.updateState("birthPlace", values.birthPlace);
            context.updateState("momName", values.momName);
            context.updateState("momName1", values.momName1);
            context.updateState("momName2", values.momName2);
            context.updateState("sex", values.sex);
            context.updateState("civilStatus", values.civilStatus);
            context.updateState("numberDependents", values.numberDependents);
            context.updateState("numberCar", values.numberCar);
            context.updateState("educ", values.educ);
            context.updateState("citizenship1", values.citizenship1);
            context.updateState("citizenship", values.citizenship);
            context.updateState("acr", values.acr);
            context.updateState("tinNo", values.tinNo);
            context.updateState("sssNo", values.sssNo);
            context.updateState("homeAddress", values.homeAddress);
            context.updateState("zipCode", values.zipCode);
            context.updateState(
              "chkPermAddSameWithHomeAdd",
              values.chkPermAddSameWithHomeAdd
            );
            context.updateState("permanentAddress", values.permanentAddress);
            context.updateState("zipCode2", values.zipCode2);
            context.updateState("homeOwner", values.homeOwner);
            context.updateState("yearStay", values.yearStay);
            context.updateState("homeAreaCode", values.homeAreaCode);
            context.updateState("homePhone", values.homePhone);
            context.updateState("mobilePhone", values.mobilePhone);
            context.updateState("emailAddress", values.emailAddress);
            context.updateState("emailAddressAlt", values.emailAddressAlt);
            context.updateState("socMed", values.socMed);
            // context.updateState("", values.);
            // context.updateState("", values.);

            actions.setSubmitting(false);
            props.handleSubmit();
          }}
        >
          {props => {
            const {
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              setFieldValue,
              isSubmitting
            } = props;
            return (
              <form noValidate autoComplete="off">
                {/* <FormControl
                  fullWidth
                  margin="dense"
                  error={errors.reference && touched.reference ? true : false}
                >
                  <InputLabel htmlFor="reference">
                    Where did you hear about EastWest Credit Card? *
                  </InputLabel>

                  <SpecialSelect
                    id="reference"
                    name="reference"
                    value={values.reference}
                    onChange={setFieldValue}
                    onBlur={handleBlur}
                    options={referencelist}
                  />
                  <FormHelperText
                    margin="dense"
                    classes={{
                      root: classes.dropdownError,
                      error: classes.error
                    }}
                    component="p"
                  >
                    {errors.reference && touched.reference && (
                      <>{errors.reference}</>
                    )}
                  </FormHelperText>
                </FormControl> */}

                {/* {values.reference.value === "10" ? (
                  <FormControl fullWidth margin="dense">
                    <TextField
                      id="refothers"
                      label="OTHERS"
                      className={classes.textField}
                      value={values.refothers}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                  </FormControl>
                ) : (
                  ""
                )} */}

                <FormControl fullWidth margin="dense">

                  <TextField
                    required
                    id="firstName"
                    label="First"
                    className={classes.textField}
                    value={values.firstName}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    helperText={
                      errors.firstName && touched.firstName
                        ? errors.firstName
                        : ""
                    }
                    error={errors.firstName && touched.firstName ? true : false}
                  />
                </FormControl>

                <FormControl fullWidth margin="dense">
                  <TextField
                    required
                    id="middleName"
                    label="Middle "
                    className={classes.textField}
                    value={values.middleName}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    helperText={
                      errors.middleName && touched.middleName
                        ? errors.middleName
                        : ""
                    }
                    error={
                      errors.middleName && touched.middleName ? true : false
                    }
                  />
                </FormControl>

                <FormControl fullWidth margin="dense">
                  <TextField
                    required
                    id="lastName"
                    label="Last"
                    className={classes.textField}
                    value={values.lastName}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    helperText={
                      errors.lastName && touched.lastName ? errors.lastName : ""
                    }
                    error={errors.lastName && touched.lastName ? true : false}
                  />
                </FormControl>

                <FormControl fullWidth margin="dense">
                  <TextField
                    required
                    id="cardName"
                    label="Name to appear on Card"
                    // placeholder="FIRST NAME"
                    className={classes.textField}
                    value={values.cardName}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    style={{ minWidth: 300 }}
                    helperText={
                      errors.cardName && touched.cardName
                        ? errors.cardName
                        : "Must not exceed 19 characters including spaces"
                    }
                    error={errors.cardName && touched.cardName ? true : false}
                  />
                </FormControl>

                <FormControl fullWidth margin="dense">
                  <TextField
                    required
                    id="birthDate"
                    label="Birthday"
                    type="date"
                    defaultValue="1970-01-01"
                    max="05/01/1970"
                    value={values.birthDate}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className={classes.textField}
                    InputLabelProps={{
                      shrink: true
                    }}
                    inputProps={{
                      min: minDate,
                      max: maxDate
                    }}
                    helperText={
                      errors.birthDate && touched.birthDate
                        ? errors.birthDate
                        : ""
                    }
                    error={errors.birthDate && touched.birthDate ? true : false}
                  />
                </FormControl>

                <FormControl fullWidth margin="dense">
                  <TextField
                    required
                    id="birthPlace"
                    label="Place of birth"
                    // placeholder="FIRST NAME"
                    className={classes.textField}
                    value={values.birthPlace}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    helperText={
                      errors.birthPlace && touched.birthPlace
                        ? errors.birthPlace
                        : ""
                    }
                    error={errors.birthPlace && touched.birthPlace ? true : false}
                  />
                </FormControl>

                <FormControl fullWidth margin="dense">
                  <FormLabel component="legend">
                    Mother's Full Maiden Name
                  </FormLabel>

                  <TextField
                    required
                    id="momName"
                    label="First"
                    // placeholder="FIRST NAME"
                    className={classes.textField}
                    value={values.momName}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    helperText={
                      errors.momName && touched.momName ? errors.momName : ""
                    }
                    error={errors.momName && touched.momName ? true : false}
                  />
                </FormControl>

                <FormControl fullWidth margin="dense">
                  <TextField
                    required
                    id="momName1"
                    label="Middle"
                    // placeholder="FIRST NAME"
                    className={classes.textField}
                    value={values.momName1}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    helperText={
                      errors.momName1 && touched.momName1 ? errors.momName1 : ""
                    }
                    error={errors.momName1 && touched.momName1 ? true : false}
                  />
                </FormControl>

                <FormControl fullWidth margin="dense">
                  <TextField
                    required
                    id="momName2"
                    label="Last"
                    // placeholder="FIRST NAME"
                    className={classes.textField}
                    value={values.momName2}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    helperText={
                      errors.momName2 && touched.momName2 ? errors.momName2 : ""
                    }
                    error={errors.momName2 && touched.momName2 ? true : false}
                  />
                </FormControl>

                <FormControl
                  className={classes.formRadio}
                  fullWidth
                  error={errors.sex && touched.sex ? true : false}
                >
                  <FormLabel component="legend">Gender *</FormLabel>

                  <SpecialRadioGroup
                    name="sex"
                    value={values.sex}
                    onChange={setFieldValue}
                    onBlur={handleBlur}
                    options={sexlist}
                  />

                  {/* <RadioGroup
                                        aria-label=""
                                        name="sex"
                                        className={classes.group}
                                        value={values.sex}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                    >
                                        <FormControlLabel value="M" control={<Radio />} label="Male" />
                                        <FormControlLabel value="F" control={<Radio />} label="Female" />
                                    </RadioGroup> */}
                  <FormHelperText
                    margin="dense"
                    classes={{
                      root: classes.radioError,
                      error: classes.error
                    }}
                    component="p"
                  >
                    {errors.sex && touched.sex && <>{errors.sex}</>}
                  </FormHelperText>
                </FormControl>

                <FormControl
                  className={classes.formRadio}
                  fullWidth
                  error={
                    errors.civilStatus && touched.civilStatus ? true : false
                  }
                >
                  <FormLabel component="legend">Civil Status *</FormLabel>

                  <SpecialRadioGroup
                    name="civilStatus"
                    value={values.civilStatus}
                    onChange={setFieldValue}
                    onBlur={handleBlur}
                    options={civilstatuslist}
                  />

                  {/* <RadioGroup
                                        aria-label=""
                                        name="civilStatus"
                                        className={classes.group}
                                        value={values.civilStatus}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                    >
                                        <FormControlLabel value="S" control={<Radio />} label="Single" />
                                        <FormControlLabel value="M" control={<Radio />} label="Married" />
                                        <FormControlLabel value="W" control={<Radio />} label="Widowed" />
                                        <FormControlLabel value="D" control={<Radio />} label="Separated" />
                                    </RadioGroup> */}
                  <FormHelperText
                    margin="dense"
                    classes={{
                      root: classes.radioError,
                      error: classes.error
                    }}
                    component="p"
                  >
                    {errors.civilStatus && touched.civilStatus && (
                      <>{errors.civilStatus}</>
                    )}
                  </FormHelperText>
                </FormControl>

                <FormControl fullWidth margin="dense">
                  <TextField
                    required
                    id="numberDependents"
                    label="No. of Dependents"
                    // placeholder="FIRST NAME"
                    className={classes.textField}
                    value={values.numberDependents}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    type="number"
                    helperText={
                      errors.numberDependents && touched.numberDependents
                        ? errors.numberDependents
                        : ""
                    }
                    error={
                      errors.numberDependents && touched.numberDependents
                        ? true
                        : false
                    }
                  />
                </FormControl>

                <FormControl fullWidth margin="dense">
                  <TextField
                    id="numberCar"
                    label="No. of Cars Owned"
                    // placeholder="FIRST NAME"
                    className={classes.textField}
                    value={values.numberCar}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    type="number"
                    helperText={
                      errors.numberCar && touched.numberCar
                        ? errors.numberCar
                        : ""
                    }
                    error={errors.numberCar && touched.numberCar ? true : false}
                  />
                </FormControl>

                <FormControl
                  className={classes.formRadio}
                  fullWidth
                  error={errors.educ && touched.educ ? true : false}
                >
                  <FormLabel component="legend">Education *</FormLabel>

                  <SpecialRadioGroup
                    name="educ"
                    value={values.educ}
                    onChange={setFieldValue}
                    onBlur={handleBlur}
                    options={educlist}
                  />

                  {/* <RadioGroup
                                        aria-label=""
                                        name="educ"
                                        className={classes.group}
                                        value={values.educ}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                    >
                                        <FormControlLabel value="HS" control={<Radio />} label="High School" />
                                        <FormControlLabel value="SC" control={<Radio />} label="Some College" />
                                        <FormControlLabel value="CO" control={<Radio />} label="College" />
                                        <FormControlLabel value="GS" control={<Radio />} label="Post Graduate" />
                                    </RadioGroup> */}
                  <FormHelperText
                    margin="dense"
                    classes={{
                      root: classes.radioError,
                      error: classes.error
                    }}
                    component="p"
                  >
                    {errors.educ && touched.educ && <>{errors.educ}</>}
                  </FormHelperText>
                </FormControl>

                <FormControl
                  className={classes.formRadio}
                  fullWidth
                  error={
                    errors.citizenship1 && touched.citizenship1 ? true : false
                  }
                >
                  <FormLabel component="legend">
                    Citizenship/Nationality *
                  </FormLabel>

                  <SpecialRadioGroup
                    name="citizenship1"
                    value={values.citizenship1}
                    onChange={setFieldValue}
                    onBlur={handleBlur}
                    options={citizenshiplist}
                  />

                  {/* <RadioGroup
                                        aria-label=""
                                        name="citizenship1"
                                        className={classes.group}
                                        value={values.citizenship1}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                    >
                                        <FormControlLabel value="Filipino" control={<Radio />} label="Filipino" />
                                        <FormControlLabel value="OTH" control={<Radio />} label="Others" />
                                    </RadioGroup> */}
                  <FormHelperText
                    margin="dense"
                    classes={{
                      root: classes.radioError,
                      error: classes.error
                    }}
                    component="p"
                  >
                    {errors.citizenship1 && touched.citizenship1 && (
                      <>{errors.citizenship1}</>
                    )}
                  </FormHelperText>
                </FormControl>

                {values.citizenship1.value === "OTH" ? (
                  <>
                    <FormControl fullWidth margin="dense">
                      <TextField
                        id="citizenship"
                        label="Specify Nationality"
                        // placeholder="FIRST NAME"
                        className={classes.textField}
                        value={values.citizenship}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                    </FormControl>

                    <FormControl fullWidth margin="dense">
                      <TextField
                        id="acr"
                        label="ACR No."
                        // placeholder="FIRST NAME"
                        className={classes.textField}
                        value={values.acr}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                    </FormControl>
                  </>
                ) : (
                  ""
                )}

                <FormControl
                  fullWidth
                  margin="dense"
                  error={errors.tinNo && touched.tinNo ? true : false}
                >
                  <InputLabel required htmlFor="tinNo">
                    Tax Identification Number (TIN)
                  </InputLabel>
                  <Input
                    id="tinNo"
                    value={values.tinNo}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={errors.tinNo && touched.tinNo ? true : false}
                    inputComponent={TinCustom}
                  />
                  <FormHelperText
                    argin="dense"
                    classes={{
                      root: classes.dropdownError,
                      error: classes.error
                    }}
                    component="p"
                  >
                    {errors.tinNo && touched.tinNo && <>{errors.tinNo}</>}
                  </FormHelperText>
                </FormControl>

                <FormControl
                  fullWidth
                  margin="dense"
                  error={errors.sssNo && touched.sssNo ? true : false}
                >
                  <InputLabel required htmlFor="sssNo">
                    SSS/GSIS No.
                  </InputLabel>
                  <Input
                    id="sssNo"
                    value={values.sssNo}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={errors.sssNo && touched.sssNo ? true : false}
                    inputComponent={SSSCustom}
                  />
                  <FormHelperText
                    argin="dense"
                    classes={{
                      root: classes.dropdownError,
                      error: classes.error
                    }}
                    component="p"
                  >
                    {errors.sssNo && touched.sssNo && <>{errors.sssNo}</>}
                  </FormHelperText>
                </FormControl>

                {/* <FormControl
										fullWidth
										margin="dense"
									>

                                        <TextField
                                            required
                                            id="sssNo"
                                            label="SSS/GSIS No."
                                            // placeholder="FIRST NAME"
                                            className={classes.textField}
                                            value={values.sssNo}
                                            onChange={handleChange}
                                            onBlur={handleBlur}

                                            helperText={errors.sssNo && touched.sssNo ? errors.sssNo : '' }
                                            error = {errors.sssNo && touched.sssNo ? true : false}
                                        />

                                    </FormControl> */}

                <FormControl fullWidth margin="dense">
                  <TextField
                    required
                    id="homeAddress"
                    label="Present/Home Address"
                    // placeholder="FIRST NAME"
                    className={classes.textField}
                    value={values.homeAddress}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    // multiline
                    // rows="2"
                    helperText={
                      errors.homeAddress && touched.homeAddress
                        ? errors.homeAddress
                        : "Limit input to 120 characters including spaces"
                    }
                    error={
                      errors.homeAddress && touched.homeAddress ? true : false
                    }
                    // helperText="Limit input to 120 characters including spaces"
                    fullWidth
                  />
                </FormControl>

                <FormControl fullWidth margin="dense">
                  <TextField
                    required
                    id="zipCode"
                    label="Zip Code"
                    // placeholder="FIRST NAME"
                    className={classes.textField}
                    value={values.zipCode}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    InputProps={{
                      inputComponent: ZipCustom
                    }}
                    helperText={
                      errors.zipCode && touched.zipCode ? errors.zipCode : ""
                    }
                    error={errors.zipCode && touched.zipCode ? true : false}
                  />
                </FormControl>

                <FormControl
                  // className={}
                  fullWidth
                  // error={errors.SOAtoBillingAdd && touched.SOAtoBillingAdd ? true : false}
                >
                  {/* <FormLabel component="legend">
									Should you prefer to receive your SOA in your billing address, please tick this box:
									</FormLabel> */}

                  <FormControlLabel
                    control={
                      <Checkbox
                        // checked={values.chkPermAddSameWithHomeAdd}
                        onChange={handleChange}
                        value="true"
                        id="chkPermAddSameWithHomeAdd"
                        name="chkPermAddSameWithHomeAdd"
                      />
                    }
                    label="Please check if same as Present/Home Address"
                  />

                  <FormHelperText
                    margin="dense"
                    classes={{
                      root: classes.radioError,
                      error: classes.error
                    }}
                    component="p"
                  >
                    {errors.chkPermAddSameWithHomeAdd &&
                      touched.chkPermAddSameWithHomeAdd && (
                        <>{errors.chkPermAddSameWithHomeAdd}</>
                      )}
                  </FormHelperText>
                </FormControl>

                <FormControl fullWidth margin="dense">
                  {values.chkPermAddSameWithHomeAdd === true ? (
                    <TextField
                      id="permanentAddress"
                      label="Permanent Address"
                      className={classes.textField}
                      value={(values.permanentAddress = values.homeAddress)}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      helperText="Limit input to 120 characters including spaces"
                      fullWidth
                    />
                  ) : (
                    <TextField
                      id="permanentAddress"
                      label="Permanent Address"
                      // placeholder="FIRST NAME"
                      className={classes.textField}
                      value={values.permanentAddress}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      // multiline
                      // rows="2"
                      helperText="Limit input to 120 characters including spaces"
                      fullWidth
                    />
                  )}
                </FormControl>

                <FormControl fullWidth margin="dense">
                  {values.chkPermAddSameWithHomeAdd === true ? (
                    <TextField
                      id="zipCode2"
                      label="Zip Code"
                      // placeholder="FIRST NAME"
                      className={classes.textField}
                      value={(values.zipCode2 = values.zipCode)}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      InputProps={{
                        inputComponent: ZipCustom
                      }}
                      helperText={
                        errors.zipCode2 && touched.zipCode2
                          ? errors.zipCode2
                          : ""
                      }
                      error={errors.zipCode2 && touched.zipCode2 ? true : false}
                    />
                  ) : (
                    <TextField
                      id="zipCode2"
                      label="Zip Code"
                      // placeholder="FIRST NAME"
                      className={classes.textField}
                      value={values.zipCode2}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      InputProps={{
                        inputComponent: ZipCustom
                      }}
                      helperText={
                        errors.zipCode2 && touched.zipCode2
                          ? errors.zipCode2
                          : ""
                      }
                      error={errors.zipCode2 && touched.zipCode2 ? true : false}
                    />
                  )}
                </FormControl>

                <FormControl
                  className={classes.formRadio}
                  fullWidth
                  error={errors.homeOwner && touched.homeOwner ? true : false}
                >
                  <FormLabel component="legend">Home Ownership *</FormLabel>

                  <SpecialRadioGroup
                    name="homeOwner"
                    value={values.homeOwner}
                    onChange={setFieldValue}
                    onBlur={handleBlur}
                    options={homeownerlist}
                  />

                  {/* <RadioGroup
                                        aria-label=""
                                        name="homeOwner"
                                        className={classes.group}
                                        value={values.homeOwner}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                    >
                                        <FormControlLabel value="OW" control={<Radio />} label="Owned, Mortgage" />
                                        <FormControlLabel value="OM" control={<Radio />} label="Owned, Not Mortgaged" />
                                        <FormControlLabel value="LP" control={<Radio />} label="Living with Parents or Relatives" />
                                        <FormControlLabel value="CP" control={<Radio />} label="Company Provided" />
                                        <FormControlLabel value="RN" control={<Radio />} label="Rented" />
                                    </RadioGroup> */}

                  <FormHelperText
                    margin="dense"
                    classes={{
                      root: classes.radioError,
                      error: classes.error
                    }}
                    component="p"
                  >
                    {errors.homeOwner && touched.homeOwner && (
                      <>{errors.homeOwner}</>
                    )}
                  </FormHelperText>
                </FormControl>

                <FormControl fullWidth margin="dense">
                  <TextField
                    required
                    id="yearStay"
                    label="Years of Stay"
                    // placeholder="FIRST NAME"
                    className={classes.textField}
                    value={values.yearStay}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    type="number"
                    helperText={
                      errors.yearStay && touched.yearStay ? errors.yearStay : ""
                    }
                    error={errors.yearStay && touched.yearStay ? true : false}
                  />
                </FormControl>

                <Grid container className={classes.homeNumber}>
                  <FormControl
                    // fullWidth
                    margin="dense"
                    error={errors.homeAreaCode ? true : false}
                  >
                    <InputLabel htmlFor="homeAreaCode">Area Code</InputLabel>
                    <Input
                      // type="number"
                      id="homeAreaCode"
                      value={values.homeAreaCode}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={
                        errors.homeAreaCode && touched.homeAreaCode
                          ? true
                          : false
                      }
                      inputComponent={HomeAreaCode}
                    />
                    <FormHelperText
                      margin="dense"
                      classes={{
                        root: classes.dropdownError,
                        error: classes.error
                      }}
                      component="p"
                    >
                      {errors.homeAreaCode ||
                        (touched.homeAreaCode && <>{errors.homeAreaCode}</>)}
                    </FormHelperText>
                  </FormControl>
                  <FormControl
                    // fullWidth
                    margin="dense"
                    error={errors.homePhone ? true : false}
                  >
                    <InputLabel htmlFor="homePhone">
                      Home Phone Number
                    </InputLabel>
                    <Input
                      // type="number"
                      id="homePhone"
                      value={values.homePhone}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={
                        errors.homePhone && touched.homePhone ? true : false
                      }
                      inputComponent={HomeTelCustom2}
                    />
                    <FormHelperText
                      margin="dense"
                      classes={{
                        root: classes.dropdownError,
                        error: classes.error
                      }}
                      component="p"
                    >
                      {errors.homePhone ||
                        (touched.homePhone && <>{errors.homePhone}</>)}
                    </FormHelperText>
                  </FormControl>
                </Grid>

                <FormControl
                  fullWidth
                  margin="dense"
                  error={
                    errors.mobilePhone && touched.mobilePhone ? true : false
                  }
                >
                  <InputLabel required htmlFor="mobilePhone">
                    Mobile Phone Number
                  </InputLabel>
                  <Input
                    // type="number"
                    id="mobilePhone"
                    value={values.mobilePhone}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={
                      errors.mobilePhone && touched.mobilePhone ? true : false
                    }
                    inputComponent={MobileCustom}
                  />
                  <FormHelperText
                    argin="dense"
                    classes={{
                      root: classes.dropdownError,
                      error: classes.error
                    }}
                    component="p"
                  >
                    {errors.mobilePhone && touched.mobilePhone && (
                      <>{errors.mobilePhone}</>
                    )}
                  </FormHelperText>
                </FormControl>

                {/* <FormControl
										fullWidth
										margin="dense"
									>

                                        <TextField
                                            required
                                            id="mobilePhone"
                                            label="Mobile Phone Number"
                                            // placeholder="FIRST NAME"
                                            className={classes.textField}
                                            value={values.mobilePhone}
                                            onChange={handleChange}
                                            onBlur={handleBlur}

                                            // style={{minWidth:200}}
                                            helperText={errors.mobilePhone && touched.mobilePhone ? errors.mobilePhone : '' }
                                            error = {errors.mobilePhone && touched.mobilePhone ? true : false}
                                        />

                                    </FormControl> */}

                <Typography variant="caption" gutterBottom>
                Your mobile number will be used for sending of cardholder notices, marketing promos, your one-time-password, security alerts, etc.  <br/>EastWest may send you an SMS to communicate the status or any update related to this application.  
                </Typography>

                <FormControl fullWidth margin="dense">
                  <TextField
                    required
                    id="emailAddress"
                    label="Primary E-mail Address"
                    className={classes.textField}
                    value={values.emailAddress}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    type="email"
                    helperText={
                      errors.emailAddress && touched.emailAddress
                        ? errors.emailAddress
                        : ""
                    }
                    error={
                      errors.emailAddress && touched.emailAddress ? true : false
                    }
                  />
                </FormControl>

                <Typography variant="caption" gutterBottom>
                Your e-mail address will be used for sending of your EastWest Credit Card electronic Statement of Account, cardholder notices, marketing promos, security alerts, online banking, etc. 
                </Typography>

                <FormControl fullWidth margin="dense">
                  <TextField
                    id="emailAddressAlt"
                    label="Alternate E-mail Address"
                    className={classes.textField}
                    value={values.emailAddressAlt}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    type="email"
                    helperText={
                      errors.emailAddressAlt && touched.emailAddressAlt
                        ? errors.emailAddressAlt
                        : ""
                    }
                    error={
                      errors.emailAddressAlt && touched.emailAddressAlt
                        ? true
                        : false
                    }
                  />
                </FormControl>

                <FormControl fullWidth margin="dense">
                  <TextField
                    id="socMed"
                    label="Social Media Accounts "
                    className={classes.textField}
                    value={values.socMed}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    helperText={
                      errors.socMed && touched.socMed
                        ? errors.socMed
                        : ""
                    }
                    error={
                      errors.socMed && touched.socMed
                        ? true
                        : false
                    }
                  />
                </FormControl>
                <Typography variant="caption" gutterBottom>
                  Your social media account will be used for sending of your EastWest credit card notices, marketing promos, etc.  
                </Typography>

                <br />

                <StepButtons
                  isSubmitting={isSubmitting}
                  activestep={activeStep}
                  handleBack={handleBack}
                  handleNext={handleSubmit}
                />
              </form>
            );
          }}
        </Formik>
      )}
    </Consumer>
  );
});

export default PersonalInformation;
